import React from "react";
import {NavLink, Link} from "react-router-dom";
import pageList from './pageList';
import Request, {CODES} from '../../utils/Request';

import UserContext from '../../utils/UserContext';
import {PERMISSIONS} from '../../utils/Request';

// import GeneralAnimations from '../utils/generalAnimations';
// import {TweenMax, Power2} from "gsap/TweenMax";


class pageListStock extends pageList {
	
	constructor(props){
		super(props)
		this.apiName = 'stock';
		this.listSlug = 'stock';
		this.singleItem = 'stock'; //Name of a single list item
		this.listTitle = 'Stock';

		this.hasRowOptions = false;
		this.getStockValue = this.getStockValue.bind(this);
	}
	
	componentDidMount(){
		this.requestPages();
	}

	getTable(pages){
		let table = {};
		table.headers = [
			{
				slug: 'brand',
				name: 'Brand',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'name',
				name: 'Nombre',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'sku',
				name: 'SKU',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'sku_soultek',
				name: 'SKU Soultek',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'sku_stk',
				name: 'SKU STK',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'provider',
				name: 'Proveedor',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'sku_provider',
				name: 'SKU Proveedor',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'stock',
				name: 'Stock',
				class: 'item-medium',
				canSort: true,
			},
			{
				slug: 'stock_almacen',
				name: 'Stock almacen',
				class: 'item-medium',
				canSort: true,
			},
			{
				slug: 'location_store',
				name: 'Almacen',
				class: 'item-medium',
			},
			{
				slug: 'bar_code',
				name: 'Código Barras',
				class: 'item-medium',
				canSearch: true,
			},
		];
		table.rows = [];
		for(let i = 0; i < pages.length; i++){
			table.rows.push(this.createRow(pages[i]));
		}
		return table;
	}

	createRow(page){
		// if(page.is_composite){
		// 	page.stock_almacen = '-';
		// }
		return {
			item : page,
			brand : page.brand,
			sku : page.sku,
			name : page.name,
			sku_soultek : page.sku_soultek,
			sku_stk : page.sku_stk,
			provider : page.provider,
			sku_provider: page.sku_provider,
			stock : page.stock,
			stock_almacen : page.stock_almacen,
			location_store: page.location_store,
			bar_code: page.bar_code,
		};
	}

	getStockValue(){
		if(!this.stockValue){
			this.stockValue = {almacen: 0, real: 0};
			for(let row of this.state.table.rows){
				this.stockValue.almacen += (row.item.price_cost*row.item.stock_almacen)
				this.stockValue.real += (row.item.price_cost*row.item.stock)
			}
		}
		alert("Valor del stock en almacen: " + this.stockValue.almacen.toFixed(2) + " €\n"+"Valor del stock actual: " + this.stockValue.real.toFixed(2) +" €")
	}

	renderBeforeAddNew(){
		return <React.Fragment>
			<UserContext.Consumer>
				{user => {
					if(PERMISSIONS.canAdministrator(user)){
						return (
							<button className="button button-default font-p font-white font-center" onClick={this.getStockValue}>Valor stock</button>
						)
					}
				}}
			</UserContext.Consumer>
			<Link to={'/productos-to-buy/'} className="font-p button">A comprar</Link>
			<Link to={'/remove-stock/'} className="font-p button">Retirar Stock</Link>
		</React.Fragment>
	}
	renderAddNew(){
		return <Link to={'/add-stock/'} className="font-p button">Añadir Stock</Link>
	}
}





export default pageListStock;




